import React from "react";
import assetsManager from "../../assets/assetsmanager/assestsmanager";
import { Globalstate } from "context/context";
import { condition } from "context/condition";
import "./backButton.css";

const BackButton = ({ style, showSimplifiText, parentStyle }) => {
  const { state, dispatch } = Globalstate();
  const authToken = localStorage.getItem("authToken");
  const handleGoToAppHome = () => {
    if (state.source === "service" && state.channel == "ABCDService") {
      window.parent.postMessage(
        {
          handlerName: "GoToABCapital",
          data: {
            token: authToken,
            destinationLobId: "26",
            channel: "156",
            functionalityCode: "D"
          }
        },
        "*"
      );
    } else if (state.source === "service") {
      let serviceHomeLink =
        process.env.REACT_APP_ENV === "uat"
          ? "https://uatoneservice.adityabirlacapital.com/home"
          : "https://oneservice.adityabirlacapital.com/home";
      window.location.href = serviceHomeLink;
    } else {
      dispatch({
        type: condition.RESETMESSAGES
      });
      dispatch({
        type: condition.ISMESSAGESUBMITTED,
        payload: false
      });
      console.log("goBackToPreviousPage");
    }
  };
  return (
    <div className={`header-top`} style={parentStyle}>
      <button onClick={handleGoToAppHome} style={style}>
        <img src={assetsManager.backIcon} alt="" />
      </button>
      {showSimplifiText && <p>SimpliFi</p>}
    </div>
  );
};

export default BackButton;
